export const formatAmount = (number) => {
  if (number === null || number === undefined) return number;
  if (isNaN(number)) return number;
  return new Intl.NumberFormat('en-IN').format(Number(number));
};
